import { render, staticRenderFns } from "./CompanyQaS.vue?vue&type=template&id=c1b2abd4&"
import script from "./CompanyQaS.vue?vue&type=script&lang=js&"
export * from "./CompanyQaS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports